<template>
    <!-- toTop -->
    <div class="to-top">
      <div class="cndns-right-item fw" id="back-to-top-1">
        <i class="iconfont icon-top" style="font-size:24px"></i>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'toTop',
  components: {
    
  },
  mounted() {
    $("#back-to-top-1").click(function () {
      $('body,html').animate({scrollTop: 0}, 1000);
      return false;
    });
  },
  methods: {
    
  }
}


</script>


<style lang="scss" scoped>

#back-to-top-1 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 2px;
    top: 90%;
    z-index: 8;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: url('../assets/images/home_to_top.png') no-repeat;
    background-size: cover;
    margin-top: -150px;
    cursor: pointer;
}

//  移动端
@media screen and (min-width: 300px) and (max-width: 760px) {
    #back-to-top-1 {
      width: 48px;
      height: 48px;
    }
}
</style>


